import {Component, Input, OnInit} from '@angular/core';
import {FolderModel} from "../../models/folder.model";
import {ExpandedFoldersService} from "../../services/expanded-folders-service";
import {SpotifyTagsService} from "../../services/spotify-tags-service";

@Component({
  selector: 'app-folders-list',
  templateUrl: './folders-list.component.html',
  styleUrls: ['./folders-list.component.css']
})
export class FoldersListComponent implements OnInit {

  @Input() folders: FolderModel[];

  constructor(public expandedFoldersService: ExpandedFoldersService, private spotifyTagsService: SpotifyTagsService) {
  }

  ngOnInit() {
  }

  toggleShowTags(show: boolean, folder: FolderModel) {
    let expandedFolders = this.expandedFoldersService.getExpandedFolders();
    if (show && !this.expandedFoldersService.expandedFolderContains(folder.folderId)) {
      expandedFolders.push(folder.folderId);
    } else if (!show && this.expandedFoldersService.expandedFolderContains(folder.folderId)) {
      let index = expandedFolders.indexOf(folder.folderId);
      expandedFolders.splice(index, 1);
    }
    this.expandedFoldersService.setExpandedFolders(expandedFolders);
  }

  navigate() {
    this.spotifyTagsService.navigate();
  }
}
